import { Link } from 'react-router-dom';
import { CadranGlyph } from './CadranGlyph.js';

// Liens "à venir" non encore routés — utilise /todo comme placeholder valide.
const TODO = '/todo';

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div>
          <div className="brand">
            <CadranGlyph size={26} color="oklch(0.92 0.014 78)" accent="var(--terracotta)" />
            <span>Cadran</span>
          </div>
          <p className="tag">
            L'horloge qui montre aussi
            <br />
            les gens qu'on aime.
          </p>
        </div>
        <div>
          <h5>Produit</h5>
          <ul>
            <li>
              <Link to="/comment-ca-marche">Comment ça marche</Link>
            </li>
            <li>
              <Link to="/tarifs">Tarifs</Link>
            </li>
            <li>
              <Link to="/faq">Aide &amp; FAQ</Link>
            </li>
            <li>
              <Link to="/inscription">Créer un foyer</Link>
            </li>
          </ul>
        </div>
        <div>
          <h5>L'atelier</h5>
          <ul>
            <li>
              <a href={TODO}>Notre histoire</a>
            </li>
            <li>
              <a href={TODO}>Le journal</a>
            </li>
            <li>
              <a href={TODO}>Presse</a>
            </li>
            <li>
              <a href={TODO}>Nous écrire</a>
            </li>
          </ul>
        </div>
        <div>
          <h5>Légal</h5>
          <ul>
            <li>
              <Link to="/mentions-legales">Mentions légales</Link>
            </li>
            <li>
              <Link to="/confidentialite">Confidentialité</Link>
            </li>
            <li>
              <Link to="/confidentialite">Sécurité des données</Link>
            </li>
            <li>
              <a href={TODO}>CGV</a>
            </li>
          </ul>
        </div>
        <div className="legal">
          <span>cadran.cloud · atelier basé à Lyon</span>
          <span>© 2026 · fait avec soin en France</span>
        </div>
      </div>
    </footer>
  );
}
